module.exports = __webpack_public_path__ + "img/DS-M-16.9704a020.svg";